import { IsString, MaxLength } from 'class-validator';

export class WikiPostSearchDTO {

    @IsString()
    @MaxLength(50)
    title: string;

}
